import React, { useState, useEffect } from 'react';
import { useTheme, makeStyles } from '@material-ui/core/styles'
import { Box, Button, IconButton, Paper, CircularProgress, Typography, TextField, TableSortLabel } from '@material-ui/core'
import { useTranslate, useDataProvider, Loading, usePermissions } from 'react-admin';
import ConfirmDialog from '../CustomizedUIs/confirmDialog';
import colors from '../CustomizedUIs/Colors'
import { Add } from '@material-ui/icons'
import icDelete from '../assets/icons/Trash-black.png'
import icArrowUp from '../assets/icons/white-arrow-up.png';
import icArrowDown from '../assets/icons/white-arrow-down.png';
import Search from '../search'
import {
    usePopupState,
    bindToggle,
} from 'material-ui-popup-state/hooks'
import CustomPopoverArrow from '../CustomizedUIs/CustomPopoverArrow'
import CategoryTable from './CategoryTable'
import EditPopup from './editCategoryPopup'
import Snackbar from '../common/snackbar';


const useStyles = makeStyles(theme => ({

    tableSortLabel: {
        color: 'theme.palette.common.white',
        '&:hover': {
            color: 'white'
        },
        '&:focus': {
            color: 'white'
        },
    },
    paper: {
        padding: '16px 16px',
        width: 300
    },
    Title: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    TitleCreate: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '14px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 2.4,
        letterSpacing: '0.15px',
        color: '#4f5064',
    },
    btnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
   
    btnSave: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '12.5px',
        letterSpacing: '0.4px',
        color: '#ffffff',
    },
    TitleName: {
        fontFamily: ' UniviaPro',
        fontSize: ' 13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#ffffff',
    },
    borderItem: {
        borderRadius: '4px',
        boxShadow: '0 3px 6px 0 rgba(27, 102, 157, 0.04)',
        backgroundColor: '#ffffff',
    },
    textValue: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '14px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#237fc2',
    },
    textError: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
    },
    textLabel: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
        color: '#88898c',
    },
    textLableError: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
    }, input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        }, fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#88898c',
    }, underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    underlineError: {
        '&::after': {
            borderBottom: '2px solid' + '#eb5a4d'
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    textEdit: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
        padding: '5px 8px 5px 8px'
    },
    icons: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 7,
        cursor: 'pointer'
    },
    icon: {
        width: 9,
        height: 9
    },
    subText: {
        fontFamily: 'UniviaPro-Medium',
        fontWeight: '500',
        lineHeight: "13.2px",
        marginLeft: 10,
        letterSpacing: 'normal',
        color: '#88898c',
        fontSize: 11
    }
}));


const CategoryMedia = () => {
    const dataProvider = useDataProvider()
    const classes = useStyles()
    const translate = useTranslate()
    const [data, setData] = useState([])
    const [filter, setFilter] = useState('')
    const { permissions, loaded } = usePermissions();
    const popupState = usePopupState({ variant: 'popper', popupId: 'createDialog' })
    const [totalCount, setTotalCount] = useState(0);
    const [showSnackbar, setShowSnackbar] = useState({
        status: false,
        name: '',
        message: ''
    })
    const [openDialog, setOpenDialog] = useState({
        data: null,
        status: false
    })
    const [openConfirmDialog, setOpenConfirmDialog] = useState({
        status: false,
        index: -1
    })
    const [sort, setSort] = useState({
        field: 'name',
        order: 'ASC'
    })
    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 10
    })

    const handleOpenDialog = () => {
        setOpenDialog({
            data: null,
            status: true
        })
    }

    const openEditDialog = (item) => {
        setOpenDialog({
            data: item,
            status: true
        })
    }

    const handleClose = () => {
        setOpenDialog({
            data: null,
            status: false
        })
    }


    const getList = () => {
        dataProvider('GET_LIST', "medias/findcategory", {
            filter: { name: { contains: filter.trim() } },
            pagination,
            sort
        })
            .then(({ data, total }) => {
                setData(data);
                setTotalCount(total)
            })
            .catch(error => {
            })
    }
    const onGetList = (sortObj, paginationObj) => {
        setSort(sortObj)
        setPagination(paginationObj)
    }

    useEffect(() => {
        getList();
    }, [sort, pagination])

    useEffect(() => {
        if (showSnackbar.status)
            getList()
    }, [showSnackbar])
    // React.useEffect(() => {
    //     !popupState.isOpen && setDataCreate('')
    // }, [popupState])



    const handleOnDelete = () => {
        if (openConfirmDialog.index > -1) {
            dataProvider('DELETE', "medias/deletecategory", {
                id: data[openConfirmDialog.index].id
            })
                .then(() => {
                    let temps = data.slice()
                    temps.splice(openConfirmDialog.index, 1)
                    setData(temps)
                    setOpenConfirmDialog({ status: false, index: -1 })
                    getList()
                })
                .catch(error => {
                    setOpenConfirmDialog({ status: false, index: -1 })
                })
        }

    }

    const handleDelete = (index) => {
        setOpenConfirmDialog({ status: true, index: index })
    }

    if (!loaded) return null

    return (
        <Box width='100%' display='flex' justifyContent='center'>
            <Box width='60%' mt={8}>
                <Box width='100%' display='flex' justifyContent='flex-end'>
                    <Snackbar
                        show={showSnackbar.status}
                        boldText={showSnackbar.name}
                        message={showSnackbar.message}
                        onClose={() => setShowSnackbar({
                            status: false,
                            name: '',
                            message: ''
                        })}
                    />
                </Box>
                <Box width='100%' display='flex' alignItems='center'>
                    <Box flexGrow={1} display="flex" flexDirection="row" alignItems="center" >
                        <Typography className={classes.Title} >{translate('pos.media.categoryMedia')}</Typography>
                        {
                            totalCount > 0 ? <Typography className={classes.subText}>({totalCount})</Typography>
                                : <Typography className={classes.subText}>(0)</Typography>
                        }
                    </Box>
                    <Search
                        placeholder={translate(`pos.categories.category`)}
                        onChangeText={setFilter}
                        getList={getList}
                    />
                    {
                        permissions.functionAction.find(value => value.function === 'Media' && value.isUpdate) &&
                        <Box ml={4}>
                            <Button onClick={handleOpenDialog} variant='contained' color='primary'>
                                <Typography className={classes.btnCreate}>{translate('pos.media.createNewCategory')}</Typography>
                                <Add />
                            </Button>
                        </Box>
                    }

                </Box>
                <Box mt={2}>
                    <CategoryTable
                        setOpenDialog={openEditDialog}
                        handleDelete={handleDelete}
                        buttonHidden={
                            !permissions.functionAction.find(value => value.function === 'Media' && value.isUpdate)
                        }
                        data={data}
                        // setData={setUser}
                        total={totalCount}
                        getList={onGetList}
                    // error={user.length}
                    />
                </Box>
            </Box>
            <EditPopup
                data={data}
                setData={setData}
                openDialog={openDialog}
                onClose={handleClose}
                setShowSnackbar={setShowSnackbar}
            />
            <ConfirmDialog
                open={openConfirmDialog.status}
                handleClose={() => { setOpenConfirmDialog({ status: false, index: -1 }) }}
                handleConfirm={handleOnDelete}
                ContentText={translate('pos.user.contentDelete')}
                Tittle={translate('pos.media.deleteMedia')} />
        </Box>
    )
}
export default CategoryMedia